import { Form, Formik } from "formik";
import React, { FC } from "react";
import Modal from 'react-modal';
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import closeIcon from '../../images/close.svg';
import EventTypeForm from "./EventTypeForm";
import { EventType } from "../../models/EventType";

interface EventTypeModalProps {
    isOpen: boolean;
    onClose: () => void;
    currentItem: EventType;
    editEventType: (values) => void;
}

const EventTypeModal: FC<EventTypeModalProps> = ({ isOpen, onClose, currentItem, editEventType }) => {
    const { translate } = useLocale();
    
    return <Modal
        isOpen={isOpen}
        ariaHideApp={false}
        overlayClassName="flex w-screen position-float fixed top-0 left-0 h-screen bg-opacity-75 bg-white"
        className="bg-white border-none m-auto shadow select-none outline-none" >
        <Formik
            enableReinitialize={true}
            initialValues={currentItem}
            onSubmit={editEventType}>
            <Form>
                <div className={`w-full p-2 border-b flex flex-row items-center bg-sidemenu-focus text-white justify-between`}>
                    <div className="flex flex-row">
                        <p className="pl-3 font-bold font text-white">{currentItem.nameOriginal}</p>
                    </div>
                    <img src={closeIcon} onClick={onClose} className="cursor-pointer mr-2" />
                </div>
                <div className="pt-3 pl-4 pr-3" style={{ width: '320px' }} >
                    <EventTypeForm />
                </div>
                <div className="flex flex-row pb-3 pr-1 justify-end bg-white">
                    <div className="flex flex-row mt-4 mr-5">
                        <button
                            id='submitBtn'
                            className="secondary secondary-enabled py-1 px-5"
                            type='submit'>
                            {translate.byKey(TranslationKeys.submit)}
                        </button>
                    </div>
                </div>
            </Form>
        </Formik>
    </Modal>
}

export default EventTypeModal;